import { authAction } from "./auth/authAction";
import { baoCaoActions } from "./bao-cao/baoCaoActions";
import { bienLaiPagingActions } from "./bien-lai/bienLaiPagingActions";
import { bienLaiViewActions } from "./bien-lai/bienLaiViewActions";
import { bienLaiViewChiTietActions } from "./bien-lai/bienLaiViewChiTietActions";
import { bienLaiViewTheoLopActions } from "./bien-lai/bienLaiViewTheoLopActions";
import { bienLaiViewTheoLopChiTietActions } from "./bien-lai/bienLaiViewTheoLopChiTietActions";
import { bienLaiViewTuyenSinhActions } from "./bien-lai/bienLaiViewTuyenSinhActions";
import { bieuDoActions } from "./bieu-do/bieuDoActions";
import { bienLaiThietLapActions } from "./category/bienLaiThietLapActions";
import { chuongTrinhDaoTaoKienThucActions } from "./category/chuongTrinhDaoTaoKienThucActions";
import { chuyenNganhActions } from "./category/chuyenNganhActions";
import { configInvoiceActions } from "./category/configInvoiceActions";
import { coSoActions } from "./category/coSoActions";
import { dotTuyenSinhActions } from "./category/dotTuyenSinhActions";
import { heActions } from "./category/heActions";
import { hinhThucNopTienActions } from "./category/hinhThucNopTien";
import { hocKyDangKyActions } from "./category/hocKyDangKyActions";
import { keHoachNamActions } from "./category/keHoachNamActions";
import { khoaActions } from "./category/khoaActions";
import { khoiNganhActions } from "./category/khoiNganhActions";
import { loaiThuChiActions } from "./category/loaiThuChiActions";
import { loaiThuNhapHocActions } from "./category/loaiThuNhapHocActions";
import { loaiThuTuyenSinhActions } from "./category/loaiThuTuyenSinhActions";
import { lopNamHocActions } from "./category/lopNamHocActions";
import { mucHocPhiTinChiActions } from "./category/mucHocPhiTinChiActions";
import { nganhActions } from "./category/nganhActions";
import { nhomloaiThuChiActions } from "./category/nhomLoaiThuChiActions";
import { trangThaiHocActions } from "./category/trangThaiHocActions";
import { voucherActions } from "./category/voucherActions";
import { layoutActions } from "./common/layoutActions";
import { dichVuHoSoActions } from "./dich-vu/dichVuHoSoActions";
import { dichVuThanhToanActions } from "./dich-vu/dichVuThanhToanActions";
import { dichVuThongTinActions } from "./dich-vu/dichVuThongTinActions";
import { dongBoCongNoActions } from "./dong-bo/dongBoCongNoActions";
import { dongBoHocPhiActions } from "./dong-bo/dongBoHocPhiActions";
import { dongBoPhiKyTucXaActions } from "./dong-bo/dongBoPhiKyTucXaActions";
import { hoaDonDienTuActions } from "./hoa-don/hoaDonDienTuActions";
import { kyHieuHoaDonActions } from "./hoa-don/kyHieuHoaDonActions";
import { danhSachLopTinChiActions } from "./lop-tin-chi/danhSachLopTinChiActions";
import { planLopTinChiActions } from "./lop-tin-chi/planLopTinChiActions";
import { danhSachMienGiamActions } from "./mien-giam/danhSachMienGiamActions";
import { hinhThucActions } from "./mien-giam/hinhThucActions";
import { hinhThucChiTietActions } from "./mien-giam/hinhThucChiTietActions";
import { hinhThucTinhActions } from "./mien-giam/hinhThucTinhActions";
import { mucThuActions } from "./muc-thu/mucThuActions";
import { mucThuTamThuActions } from "./muc-thu/mucThuTamThuActions";
import { mucThuTinChiActions } from "./muc-thu/mucThuTinChiActions";
import nganHangActions from "./ngan-hang/nganHangActions";
import { reportActions } from "./report/reportActions";
import { reportNhapHocActions } from "./report/reportNhapHocActions";
import { reportTamThuActions } from "./report/reportTamThuActions";
import { tongHopSinhVienActions } from "./report/tongHopSinhVienActions";
import { heSoLopTuNguyenActions } from "./thiet-lap/heSoLopTuNguyenActions";
import { thuPhiNhapHocActions } from "./thu-phi-nhap-hoc/thuPhiActions";
import { thuPhiTamThuActions } from "./thu-phi-tam-thu/thuPhiActions";
import { importTuyenSinhActions } from "./thu-phi-tuyen-sinh/importActions";
import { thuPhiTuyenSinhActions } from "./thu-phi-tuyen-sinh/thuPhiActions";
import { thuPhiActions } from "./thu-phi/thuPhiActions";
import { thuPhiTheoLopActions } from "./thu-phi/thuPhiTheoLopActions";

export const rootActions = {
  auth: authAction,
  common: {
    layout: layoutActions,
  },
  category: {
    loaiThuChi: loaiThuChiActions,
    mucHocPhiTinChi: mucHocPhiTinChiActions,
    chuyenNganh: chuyenNganhActions,
    keHoachNam: keHoachNamActions,
    nganh: nganhActions,
    he: heActions,
    lopNamHoc: lopNamHocActions,
    nhomLoaiThuChi: nhomloaiThuChiActions,
    chuongTrinhDaoTaoKienThuc: chuongTrinhDaoTaoKienThucActions,
    hinhThucNopTien: hinhThucNopTienActions,
    hocKyDangKy: hocKyDangKyActions,
    khoa: khoaActions,
    bienLaiThietLap: bienLaiThietLapActions,
    dotTuyenSinh: dotTuyenSinhActions,
    loaiThuNhapHoc: loaiThuNhapHocActions,
    loaiThuTuyenSinh: loaiThuTuyenSinhActions,
    coSo: coSoActions,
    khoiNganh: khoiNganhActions,
    voucher: voucherActions,
    configInvoice: configInvoiceActions,
    trangThaiHoc: trangThaiHocActions,
  },
  nganHang: {
    nganHang: nganHangActions,
  },
  mucThu: {
    mucThu: mucThuActions,
    mucThuTinChi: mucThuTinChiActions,
    mucthuTamThu: mucThuTamThuActions,
  },
  mienGiam: {
    hinhThuc: hinhThucActions,
    hinhThucChiTiet: hinhThucChiTietActions,
    hinhThucTinh: hinhThucTinhActions,
    danhSachMienGiam: danhSachMienGiamActions,
  },
  thuPhi: {
    thuPhi: thuPhiActions,
    thuPhiTheoLop: thuPhiTheoLopActions,
    thuPhiNhapHoc: thuPhiNhapHocActions,
    thuPhiTuyenSinh: thuPhiTuyenSinhActions,
    importTuyenSinh: importTuyenSinhActions,
    thuPhiTamThu: thuPhiTamThuActions,
  },
  bienLai: {
    bienLaiView: bienLaiViewActions,
    bienLaiViewTuyenSinh: bienLaiViewTuyenSinhActions,
    bienLaiViewTheoLop: bienLaiViewTheoLopActions,
    bienLaiViewChiTiet: bienLaiViewChiTietActions,
    bienLaiViewTheoLopChiTiet: bienLaiViewTheoLopChiTietActions,
    bienLaiPaging: bienLaiPagingActions,
  },
  hoaDon: {
    hoaDonDienTu: hoaDonDienTuActions,
    kyHieuHoaDon: kyHieuHoaDonActions,
  },
  report: {
    report: reportActions,
    reportNhapHoc: reportNhapHocActions,
    reportTamThu: reportTamThuActions,
    sinhVien: tongHopSinhVienActions,
  },
  lopTinChi: {
    planLopTinChi: planLopTinChiActions,
    danhSachLoptinChi: danhSachLopTinChiActions,
  },
  baoCao: {
    baoCao: baoCaoActions,
  },
  bieuDo: {
    bieuDo: bieuDoActions,
  },
  dongBo: {
    hocPhi: dongBoHocPhiActions,
    kyTucXa: dongBoPhiKyTucXaActions,
    congNo: dongBoCongNoActions,
  },
  thietLap: {
    heSoLopTuNguyen: heSoLopTuNguyenActions,
  },
  dichVu: {
    hoSo: dichVuHoSoActions,
    thanhToan: dichVuThanhToanActions,
    thongTin: dichVuThongTinActions,
  },
};
